import { useEffect, useState, type RefObject } from "react";

export const useMeasuredHeight = ({ ref, enabled }: { ref: RefObject<HTMLElement | null>; enabled: boolean }) => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!enabled || !element || typeof ResizeObserver === "undefined") {
      setHeight(0);
      return;
    }
    const measure = () => setHeight(element.offsetHeight);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, enabled]);

  return height;
};
